module.exports = __webpack_public_path__ + "media/investors/investor-dashboard-13e8f409.png";